import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import ReglaNegocioContainer from './ReglaNegocioContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import ReglaNegocioCreateContainer from "./ReglaNegocioCreateContainer";

import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";


const mapStateToProps = (state) => {

	state.ReglaNegocioReducer.getResponDataReglaNegocio		= false;
	state.ReglaNegocioReducer.errorResponDataReglaNegocio	= false;
	state.ReglaNegocioReducer.getReglaNegocioDetail			= false;
	state.ReglaNegocioReducer.errorReglaNegocioDetail		= false;
	state.ReglaNegocioReducer.getResponDataReglaNegocioC	= false;
	state.ReglaNegocioReducer.errorResponDataReglaNegocioC	= false;
	state.ReglaNegocioReducer.getReglaNegocioBorrar			= false;
	state.ReglaNegocioReducer.errorReglaNegocioBorrar		= false;

	state.ReglaNegocioReducer.getReglaNegocioActivar		= false;
	state.ReglaNegocioReducer.errorReglaNegocioActivar		= false;


	return {
		getResponDataReglaNegocio: state.ReglaNegocioReducer.getResponDataReglaNegocio,
		errorResponDataReglaNegocio: state.ReglaNegocioReducer.errorResponDataReglaNegocio,
		getReglaNegocioDetail: state.ReglaNegocioReducer.getReglaNegocioDetail,
		errorReglaNegocioDetail: state.ReglaNegocioReducer.errorReglaNegocioDetail,
		getResponDataReglaNegocioC: state.ReglaNegocioReducer.getResponDataReglaNegocioC,
		errorResponDataReglaNegocioC: state.ReglaNegocioReducer.errorResponDataReglaNegocioC,
		getReglaNegocioBorrar: state.ReglaNegocioReducer.getReglaNegocioBorrar,
		errorReglaNegocioBorrar: state.ReglaNegocioReducer.errorReglaNegocioBorrar,
		getReglaNegocioActivar: state.ReglaNegocioReducer.getReglaNegocioActivar,
		errorReglaNegocioActivar:state.ReglaNegocioReducer.errorReglaNegocioActivar,

	};
};


class ReglaNegocio extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Reglas Establecidas</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Listar Reglas Negocio</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								
								<NavItem>
									<Link
										to={"/crearreglanegocio"}
										className={classnames({ active: activeTab === 3 })}
										onClick={() => this.setState({ activeTab: 3 })}
									>
										Agregar
    			               </Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<ReglaNegocioContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default withRouter(connect(mapStateToProps, null)(ReglaNegocio));

